module.exports = __webpack_public_path__ + "e0106718/img/arrow-share-icon.00a12c29.svg";